import './helpers.js';
import './config.js';
import { b as registerComponent, u as use } from './plugins-fd6ae0b0.js';
import './Icon-e122440c.js';
import './FormElementMixin-4407564b.js';
import './Input-a5e3ba49.js';
import './MatchMediaMixin-452a1029.js';
import './trapFocus-25a621e6.js';
import './DropdownItem-cbd6340d.js';
import './Select-3f93be0f.js';
import { _ as __vue_component__ } from './Timepicker-4aa254a6.js';
export { _ as BTimepicker } from './Timepicker-4aa254a6.js';

const Plugin = {
  install(Vue) {
    registerComponent(Vue, __vue_component__);
  }

};
use(Plugin);

export default Plugin;
